window.pageMixins = [
  {
    data() {
      return {
        isAgreement: false
      }
    },
  }
];